<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="container my-5 d-body">
    <div>
        <div class="my-3">
            <div class="font20">Messages</div>
          </div>
      <div class="row">
        <div class="col-lg-4 col-sm-12">
          <div class="mentor-card">
            <div
            class="card-header font18 d-flex justify-content-between align-items-center"
          >
                <div class="col-12">
                    <input 
                    class="form-control"
                    type="text" 
                    placeholder="Search"
                    #query
                    (keyup)="filter(query.value)" />
                </div>
          </div>
            <div class="card-body">
              <p class="mx-auto p-3" *ngIf="mentors?.length === 0">You have no chat yet</p>
              <div class="pb-4 pt-3">
                <div
                  *ngFor="let mentor of mentors"
                  class="click mentorCard"
                  [ngClass]="{ isActive: mentor?.from.user.id === mentorId }"
                >
                  <div class="px-4 py-2 d-flex  align-items-center border-radius">
                    <div
                      class="d-flex  align-items-center"
                      (click)="setMentor(mentor?.from.user.id, mentor.content)"
                    >
                      <div class="profile mr-3 ">
                        <img src="{{
                            mentor?.from?.user?.avatarUrl
                              ? mentor?.from?.user?.avatarUrl
                              : 'assets/images/avatar.jpg'
                          }}" alt="" class="w-10 rounded-circle" width="50" height="50"
                        />
                      </div>
                      <div class="mr-5">
                        <p class="mb-1 font-bold">
                          {{ mentor?.from?.user?.fullName }}
                        </p>
                        <p class="mb-0 text-grey font14">
                          {{ mentor?.mentor?.user.username }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-8 col-sm-12 sm-mt" *ngIf="!emptyMessage">
          <div class="mentor-card">
            <div
            class="card-header font18 d-flex justify-content-between align-items-center"
          >
            <div>Chats</div>
          </div>
            <div class="card-body">
              <div class="py-4  px-2">
                <div class="row">
                  <div *ngIf="!mentorId" class="p-4 mx-auto">
                    Please select a mentor to view messages
                  </div>
                    <div class="col-12" *ngIf="messages != '' ">
                        <div class="p-3">
                            <button
                                class="btn btn-outline-secondary btn-sm mr-4"
                                data-toggle="modal"
                                data-target="#sendMessageModal"
                            >
                                Send Message
                            </button>
                        </div>
                        <div class="p-4 bg-grey">
                            {{ messages }}
                        </div>
                        
                            <!-- sendMessage Modal -->
                            <div
                            class="modal fade"
                            id="sendMessageModal"
                            tabindex="-1"
                            role="dialog"
                            aria-labelledby="sendMessageModalLabel"
                            aria-hidden="true"
                            >
                            <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                <h4 class="modal-title" id="sendMessageModalLabel">
                                    Send Message to {{ mentor?.from.user?.fullName }}
                                </h4>
                                <button
                                    type="button"
                                    class="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                </div>
                                <div class="modal-body px-4">
                                <div class="hidden">
                                    <form action="" [formGroup]="messageForm">
                                    <div class="row align-items-center p-3">
                                        <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Message Subject"
                                        formControlName="subject"
                                        />
                                    </div>
                                    <div>
                                        <textarea
                                        class="form-control"
                                        placeholder=" Enter message here "
                                        formControlName="content"
                                        [ngClass]="{
                                            'is-invalid':
                                            messageForm.get('content').errors &&
                                            messageForm.get('content').touched
                                        }"
                                        ></textarea>
                                    </div>
                                    </form>
                                </div>
                                </div>
                                <div class="my-4  text-center">
                                    <button
                                        type="button"
                                        (click)="sendMessage(mentorId)"
                                        class="btn btn-secondary"
                                        data-dismiss="modal"
                                        [disabled]="messageForm.invalid"
                                    >
                                        Send Message
                                    </button>
                                </div>
                            </div>
                            </div>
                            </div>
                        <!-- <div class="p-3">
                            <form [formGroup]="messageForm">
                                <div class="input-group">
                                    <textarea formControlName="content" class="form-control" aria-label="With textarea"></textarea>
                                    <button class="btn btn-success" (click)="sendMessage(mentor?.from.user.id)">Secnd Message</button>
                                </div>
                            </form>
                        </div> -->
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-auto">
      <hr />
      <iq-central-front-end-footer></iq-central-front-end-footer>
    </div>
</section>




